{
  "REPORT": {
    "HEADER": "Konuşmalar",
    "LOADING_CHART": "Grafik verileri yükleniyor...",
    "NO_ENOUGH_DATA": "Rapor oluşturmak için yeterli veri yok, Lütfen daha sonra tekrar deneyin.",
    "DOWNLOAD_AGENT_REPORTS": "Etken raporları indir",
    "DATA_FETCHING_FAILED": "Veri çekme başarısız oldu, lütfen daha sonra tekrar deneyin.",
    "SUMMARY_FETCHING_FAILED": "Özet çekme başarısız oldu, lütfen daha sonra tekrar deneyin.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konuşmalar",
        "DESC": "( Toplam )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Gelen Mesajlar",
        "DESC": "( Toplam )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Giden Mesajlar",
        "DESC": "( Toplam )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "İlk Cevap Süresi",
        "DESC": "(Ort.)",
        "INFO_TEXT": "Hesaplama için kullanılan toplam görüşme sayısı:",
        "TOOLTIP_TEXT": "İlk Cevap Süresi {metricValue} ( {conversationCount} görüşmeye dayalı )"
      },
      "RESOLUTION_TIME": {
        "NAME": "Çözüm Süresi",
        "DESC": "(Ort.)",
        "INFO_TEXT": "Hesaplama için kullanılan toplam görüşme sayısı:",
        "TOOLTIP_TEXT": "Çözüm Süresi {metricValue} ( {conversationCount} görüşmeye dayalı )"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Çözünürlük Sayısı",
        "DESC": "( Toplam )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Çözüm Sayısı",
        "DESC": "( Toplam )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Toplam )"
      },
      "REPLY_TIME": {
        "NAME": "Müşteri Bekleme Süresi",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Bugün",
      "YESTERDAY": "Dün",
      "LAST_7_DAYS": "Son 7 gün",
      "LAST_30_DAYS": "Son 30 gün",
      "THIS_MONTH": "Bu ay",
      "LAST_MONTH": "Geçen ay",
      "LAST_3_MONTHS": "Son 3 ay",
      "LAST_6_MONTHS": "Son 6 ay",
      "LAST_YEAR": "Geçen yıl",
      "CUSTOM_DATE_RANGE": "Özel tarih aralığı"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Uygula",
      "PLACEHOLDER": "Tarih aralığı seç"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Gruplandır",
    "DURATION_FILTER_LABEL": "Süre",
    "GROUPING_OPTIONS": {
      "DAY": "Gün",
      "WEEK": "Hafta",
      "MONTH": "Ay",
      "YEAR": "Yıl"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Gün"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Gün"
      },
      {
        "id": 2,
        "groupBy": "Hafta"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Gün"
      },
      {
        "id": 2,
        "groupBy": "Hafta"
      },
      {
        "id": 3,
        "groupBy": "Ay"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Gün"
      },
      {
        "id": 2,
        "groupBy": "Hafta"
      },
      {
        "id": 3,
        "groupBy": "Ay"
      }
    ],
    "BUSINESS_HOURS": "İş Saatleri",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Kayıt bulunamadı"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Konuşmalar: {count}",
      "RESULT_COUNT_MESSAGE": "Mesajlar: {count}",
      "EMPTY": "Bu çubuk için kayıt bulunamadı.",
      "ERROR": "Kayıtlar yüklenemedi. Lütfen tekrar deneyin.",
      "LOAD_MORE": "Daha fazla yükle",
      "PREVIOUS_BUCKET": "Önceki çubuk",
      "NEXT_BUCKET": "Sonraki çubuk",
      "UNKNOWN_CONTACT": "Bilinmeyen kişi",
      "UNKNOWN_INBOX": "Bilinmeyen gelen kutusu",
      "UNASSIGNED_AGENT": "Atanmamış",
      "NO_MESSAGE_CONTENT": "Mesaj içeriği yok",
      "MESSAGE_CREATED_AT": "Mesaj oluşturulma zamanı: {time}",
      "EVENT_OCCURRED_AT": "Olay zamanı: {time}",
      "INCOMING_MESSAGE": "Gelen mesaj",
      "OUTGOING_MESSAGE": "Giden mesaj",
      "VIEW_ALL": "Konuşmalarda görüntüle",
      "VIEW_ALL_LIMIT": "Konuşma listesinde yalnızca en fazla {limit} konuşma içeren çubuklar açılır.",
      "HIDDEN_COUNT": "Gelen kutusunun üyesi olmadığınız için gösterilmiyor: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Temsilci Genel Bakış",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Grafik verileri yükleniyor...",
    "NO_ENOUGH_DATA": "Rapor oluşturmak için yeterli veri yok, Lütfen daha sonra tekrar deneyin.",
    "DOWNLOAD_AGENT_REPORTS": "Etken raporları indir",
    "FILTER_DROPDOWN_LABEL": "Temsilci Seçin",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konuşmalar",
        "DESC": "( Toplam )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Gelen Mesajlar",
        "DESC": "( Toplam )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Giden Mesajlar",
        "DESC": "( Toplam )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "İlk Cevap Süresi",
        "DESC": "(Ort.)",
        "INFO_TEXT": "Hesaplama için kullanılan toplam görüşme sayısı:",
        "TOOLTIP_TEXT": "İlk Cevap Süresi {metricValue} ( {conversationCount} görüşmeye dayalı )"
      },
      "RESOLUTION_TIME": {
        "NAME": "Çözüm Süresi",
        "DESC": "(Ort.)",
        "INFO_TEXT": "Hesaplama için kullanılan toplam görüşme sayısı:",
        "TOOLTIP_TEXT": "Çözüm Süresi {metricValue} ( {conversationCount} görüşmeye dayalı )"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Çözünürlük Sayısı",
        "DESC": "( Toplam )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Son 7 gün"
      },
      {
        "id": 1,
        "name": "Son 30 gün"
      },
      {
        "id": 2,
        "name": "Son 3 ay"
      },
      {
        "id": 3,
        "name": "Son 6 ay"
      },
      {
        "id": 4,
        "name": "Geçen yıl"
      },
      {
        "id": 5,
        "name": "Özel tarih aralığı"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Uygula",
      "PLACEHOLDER": "Tarih aralığı seç"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Etiketler Genel Bakış",
    "DESCRIPTION": "Etiketlerin performansını konuşmalar, yanıt süreleri, çözüm süreleri ve çözülen vakalar gibi temel metriklerle takip edin.",
    "LOADING_CHART": "Grafik verileri yükleniyor...",
    "NO_ENOUGH_DATA": "Rapor oluşturmak için yeterli veri yok, Lütfen daha sonra tekrar deneyin.",
    "DOWNLOAD_LABEL_REPORTS": "Etiket raporlarını indir",
    "FILTER_DROPDOWN_LABEL": "Etiket Seçin",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konuşmalar",
        "DESC": "( Toplam )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Gelen Mesajlar",
        "DESC": "( Toplam )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Giden Mesajlar",
        "DESC": "( Toplam )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "İlk Cevap Süresi",
        "DESC": "(Ort.)",
        "INFO_TEXT": "Hesaplama için kullanılan toplam görüşme sayısı:",
        "TOOLTIP_TEXT": "İlk Cevap Süresi {metricValue} ( {conversationCount} görüşmeye dayalı )"
      },
      "RESOLUTION_TIME": {
        "NAME": "Çözüm Süresi",
        "DESC": "(Ort.)",
        "INFO_TEXT": "Hesaplama için kullanılan toplam görüşme sayısı:",
        "TOOLTIP_TEXT": "Çözüm Süresi {metricValue} ( {conversationCount} görüşmeye dayalı )"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Çözünürlük Sayısı",
        "DESC": "( Toplam )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Son 7 gün"
      },
      {
        "id": 1,
        "name": "Son 30 gün"
      },
      {
        "id": 2,
        "name": "Son 3 ay"
      },
      {
        "id": 3,
        "name": "Son 6 ay"
      },
      {
        "id": 4,
        "name": "Geçen yıl"
      },
      {
        "id": 5,
        "name": "Özel tarih aralığı"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Uygula",
      "PLACEHOLDER": "Tarih aralığı seç"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Gelen Kutusu Genel Bakış",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Grafik verileri yükleniyor...",
    "NO_ENOUGH_DATA": "Rapor oluşturmak için yeterli veri yok, Lütfen daha sonra tekrar deneyin.",
    "DOWNLOAD_INBOX_REPORTS": "Gelen Kutu Raporlarını İndir",
    "FILTER_DROPDOWN_LABEL": "Gelen kutusu seç",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konuşmalar",
        "DESC": "( Toplam )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Gelen Mesajlar",
        "DESC": "( Toplam )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Giden Mesajlar",
        "DESC": "( Toplam )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "İlk Cevap Süresi",
        "DESC": "(Ort.)",
        "INFO_TEXT": "Hesaplama için kullanılan toplam görüşme sayısı:",
        "TOOLTIP_TEXT": "İlk Cevap Süresi {metricValue} ( {conversationCount} görüşmeye dayalı )"
      },
      "RESOLUTION_TIME": {
        "NAME": "Çözüm Süresi",
        "DESC": "(Ort.)",
        "INFO_TEXT": "Hesaplama için kullanılan toplam görüşme sayısı:",
        "TOOLTIP_TEXT": "Çözüm Süresi {metricValue} ( {conversationCount} görüşmeye dayalı )"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Çözünürlük Sayısı",
        "DESC": "( Toplam )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Son 7 gün"
      },
      {
        "id": 1,
        "name": "Son 30 gün"
      },
      {
        "id": 2,
        "name": "Son 3 ay"
      },
      {
        "id": 3,
        "name": "Son 6 ay"
      },
      {
        "id": 4,
        "name": "Geçen yıl"
      },
      {
        "id": 5,
        "name": "Özel tarih aralığı"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Uygula",
      "PLACEHOLDER": "Tarih aralığını seçin"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Ekip Genel Bakışı",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Grafik verileri yükleniyor...",
    "NO_ENOUGH_DATA": "Rapor oluşturmak için yeterli veri yok, Lütfen daha sonra tekrar deneyin.",
    "DOWNLOAD_TEAM_REPORTS": "Ekip raporlarını indir",
    "FILTER_DROPDOWN_LABEL": "Ekip Seç",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konuşmalar",
        "DESC": "( Toplam )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Gelen Mesajlar",
        "DESC": "( Toplam )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Giden Mesajlar",
        "DESC": "( Toplam )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "İlk Cevap Süresi",
        "DESC": "(Ort.)",
        "INFO_TEXT": "Hesaplama için kullanılan toplam görüşme sayısı:",
        "TOOLTIP_TEXT": "İlk Cevap Süresi {metricValue} ( {conversationCount} görüşmeye dayalı )"
      },
      "RESOLUTION_TIME": {
        "NAME": "Çözüm Süresi",
        "DESC": "(Ort.)",
        "INFO_TEXT": "Hesaplama için kullanılan toplam görüşme sayısı:",
        "TOOLTIP_TEXT": "Çözüm Süresi {metricValue} ( {conversationCount} görüşmeye dayalı )"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Çözünürlük Sayısı",
        "DESC": "( Toplam )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Son 7 gün"
      },
      {
        "id": 1,
        "name": "Son 30 gün"
      },
      {
        "id": 2,
        "name": "Son 3 ay"
      },
      {
        "id": 3,
        "name": "Son 6 ay"
      },
      {
        "id": 4,
        "name": "Geçen yıl"
      },
      {
        "id": 5,
        "name": "Özel tarih aralığı"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Uygula",
      "PLACEHOLDER": "Tarih aralığını seçin"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT Raporları",
    "NO_RECORDS": "Mevcut CSAT anket yanıtları yok.",
    "DOWNLOAD": "CSAT Raporlarını İndir",
    "DOWNLOAD_FAILED": "CSAT Raporlarını İndirme Başarısız Oldu",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Temsilcileri Seç"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "İletişim",
        "AGENT_NAME": "Atanan temsilci",
        "RATING": "Değerlendirme",
        "FEEDBACK_TEXT": "Geri bildirim yorumu"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Toplam yanıtlar",
        "TOOLTIP": "Toplanan yanıt sayısının toplamı"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Memnuniyet puanı",
        "TOOLTIP": "Pozitif yanıtların toplamı / Toplam yanıt sayısı * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Yanıt oranı",
        "TOOLTIP": "Toplam yanıtların toplamı / Gönderilen CSAT anketi mesajlarının toplamı * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Konuşma Sayısı",
        "TOOLTIP": "Bot mesajı içeren toplam konuşma sayısı"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Yanıt Sayısı",
        "TOOLTIP": "Toplam giden mesaj sayısı"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Yapay Zeka Yanıt Sayısı",
        "TOOLTIP": "Bot tarafından gönderilen toplam yanıt mesajı sayısı"
      },
      "COPILOT_COUNT": {
        "LABEL": "Hazırlanan Yanıt Sayısı",
        "TOOLTIP": "Bot tarafından temsilciler için hazırlanan toplam öneri sayısı"
      },
      "SUCCESS_RATE": {
        "LABEL": "Yapay Zeka Tarafından Çözülen",
        "TOOLTIP": "Temsilciye aktarılmadan yapay zeka tarafından çözülen konuşmaların yüzdesi"
      },
      "RESOLVE_TIME": {
        "LABEL": "Çözüm Süresi",
        "TOOLTIP": "İlk müşteri mesajından son bot/temsilci mesajına kadar geçen medyan süre"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "Konuşma sayısı",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Toplam yanıt",
        "TOOLTIP": "Bot tarafından gönderilen toplam yanıt sayısı"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Çözüm Oranı",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "Gruplama",
      "INBOXES": "Gelen Kutuları",
      "LABELS": "Etiketler"
    },
    "GROUPED": {
      "CHART_TITLE": "Gruba göre dağılım",
      "BACK_TO_ALL": "Tümünü göster",
      "TABLE": {
        "INBOX": "Gelen Kutusu",
        "LABEL": "Etiket",
        "CONVERSATIONS": "Konuşmalar",
        "MESSAGES": "Mesajlar",
        "MESSAGES_TOOLTIP": "Toplam giden mesaj sayısı",
        "AI_MESSAGES": "Yapay Zeka Yanıtları",
        "AI_MESSAGES_TOOLTIP": "Toplam yapay zeka yanıtı sayısı, ardından son kullanıcıların olumlu ve olumsuz değerlendirme sayısı",
        "THUMBS_UP_TOOLTIP": "Son kullanıcılar tarafından olumlu (beğenildi) olarak değerlendirilen yapay zeka yanıtı sayısı",
        "THUMBS_DOWN_TOOLTIP": "Son kullanıcılar tarafından olumsuz (beğenilmedi) olarak değerlendirilen yapay zeka yanıtı sayısı",
        "PREPARED": "Hazırlanan Yanıtlar",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Bu gruba ait mesajların tüm mesajlar içindeki yüzdesi",
        "BOT_RESPONSES": "Yapay Zeka Yanıtı %",
        "SUGGESTION_USED": "Kullanılan Yanıtlar",
        "SUGGESTION_USED_TOOLTIP": "Bu grupta temsilciler tarafından kullanılan hazırlanmış yanıtların yüzdesi",
        "SUGGESTION_NOT_USED": "Kullanılmayan Yanıtlar",
        "SUGGESTION_NOT_USED_TOOLTIP": "Bu grupta hazır bir yanıtı olup kullanılmayan mesajların yüzdesi"
      },
      "NOTES": {
        "TITLE": "Metrikler nasıl hesaplanır",
        "CONVERSATIONS": "Seçilen dönemde en az bir giden mesajı olan konuşma sayısı.",
        "MESSAGES": "Seçilen dönemde gönderilen toplam giden (özel olmayan) mesaj sayısı. Buna hem yapay zeka tarafından oluşturulan hem de insan tarafından yazılan mesajlar dahildir.",
        "PERCENTAGE": "Bu grubun mesajlarının, tüm gruplardaki toplam giden mesajlar içindeki payı.",
        "AI_MESSAGES": "Yapay zeka botu tarafından otomatik olarak gönderilen giden mesaj sayısı (temsilciler için hazırlanan yanıtlar hariç). Parantez içindeki sayılar, bu yanıtlardan kaçının son kullanıcılar tarafından olumlu (beğenildi) ve olumsuz (beğenilmedi) olarak değerlendirildiğini gösterir.",
        "PREPARED": "Seçilen dönemde yapay zeka botu tarafından temsilciler için oluşturulan öneri (hazırlanmış yanıt) sayısı. Bunlar yalnızca temsilcilerin görebildiği özel mesajlardır ve giden mesaj olarak sayılmaz, bu nedenle bu sayı Mesajlar sütunuyla birebir örtüşmeyebilir.",
        "SUGGESTION_USED": "Bu grupta temsilciler tarafından kullanılan hazırlanmış yanıtların yüzdesi. Önceki dönemlerde oluşturulan önerileri de içerebileceğinden bu oran, Hazırlanan Yanıtlar sayısıyla birebir örtüşmeyebilir.",
        "SUGGESTION_NOT_USED": "Bu grupta bir öneri mevcut olduğu halde temsilcinin kullanmadan yanıt verdiği giden mesajların yüzdesi. Yalnızca temsilcinin fiilen bir yanıt gönderdiği durumlar sayılır. Önceki dönemlerde oluşturulan önerileri de içerebileceğinden bu oran, Hazırlanan Yanıtlar sayısıyla birebir örtüşmeyebilir."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Genel Bakış",
    "LIVE": "Canlı",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Açık Konuşmalar",
      "LOADING_MESSAGE": "Görüşme metrikleri yükleniyor...",
      "OPEN": "Açık",
      "UNATTENDED": "İlgilenilmemiş",
      "UNASSIGNED": "Atanmamış",
      "PENDING": "Bekliyor"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Konuşma Trafik",
      "NO_CONVERSATIONS": "Hiç konuşma yok",
      "CONVERSATION": "{count} konuşma",
      "CONVERSATIONS": "{count} konuşmalar",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Temsilciler Tarafından Yapılan Konuşmalar",
      "LOADING_MESSAGE": "Temsilci metrikleri yükleniyor...",
      "NO_AGENTS": "Temsilciler tarafından yapılan konuşma yok",
      "TABLE_HEADER": {
        "AGENT": "Kullanıcı",
        "OPEN": "Açık",
        "UNATTENDED": "İlgilenilmemiş",
        "STATUS": "Durum"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Ekip",
        "OPEN": "Açık",
        "UNATTENDED": "İlgilenilmemiş",
        "STATUS": "Durum"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Temsilci Durumu",
      "ONLINE": "Çevrimiçi",
      "BUSY": "Meşgul",
      "OFFLINE": "Çevrimdışı"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Pazar",
    "MONDAY": "Pazartesi",
    "TUESDAY": "Salı",
    "WEDNESDAY": "Çarşamba",
    "THURSDAY": "Perşembe",
    "FRIDAY": "Cuma",
    "SATURDAY": "Cumartesi"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Filtre Ekle",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Kayıt bulunamadı",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Temsilci adı",
        "INBOXES": "Inbox adı",
        "LABELS": "Etiket adı",
        "TEAMS": "Ekip İsmi"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Gelen Kutusu",
      "AGENTS": "Kullanıcı",
      "LABELS": "Etiket",
      "TEAMS": "Ekip"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Sohbet",
        "AGENT": "Kullanıcı"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Ara toplam",
    "NO_TEAM": "Takım yok",
    "GROUP_BY_TEAMS": "Takımlara göre grupla",
    "INBOX": "Gelen Kutusu",
    "AGENT": "Kullanıcı",
    "TEAM": "Ekip",
    "LABEL": "Etiket",
    "TOTAL": "Toplam",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Çözünürlük Sayısı",
    "CONVERSATIONS": "Konuşmaların sayısı",
    "OUTGOING_CHATS": "Giden sohbetler",
    "OUTGOING_EMAILS": "Giden e-postalar",
    "PHONE_CALLS": "Telefon görüşmeleri",
    "INBOUND_CALLS": "Gelen çağrılar",
    "OUTBOUND_CALLS": "Giden çağrılar",
    "TOTAL_ACTIVITIES": "Toplam etkinlik",
    "ONLINE_TIME": "Çevrimiçi süre",
    "QUEUE_AVAILABLE_TIME": "Kuyrukta müsait olunan süre",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Bu temsilcinin gönderdiği giden mesaj sayısı",
      "OUTGOING_EMAILS": "Bu temsilcinin gönderdiği giden e-posta sayısı",
      "PHONE_CALLS": "Bu temsilciye atanan toplam telefon görüşmesi sayısı (gelen ve giden çağrıların toplamı)",
      "TOTAL_ACTIVITIES": "Toplam etkinlik sayısı: gelen çağrılar + giden çağrılar + giden sohbetler + giden e-postalar",
      "INBOUND_CALLS": "Bu temsilciye atanan gelen telefon çağrısı sayısı",
      "OUTBOUND_CALLS": "Bu temsilciye atanan giden telefon çağrısı sayısı",
      "AVG_FIRST_RESPONSE_TIME": "Bu temsilciye atanan konuşmalarda, konuşmanın oluşturulmasından temsilcinin ilk yanıtına kadar geçen ortalama süre",
      "AVG_RESOLUTION_TIME": "Bu temsilciye atanan konuşmalarda, konuşmanın oluşturulmasından çözülmesine kadar geçen ortalama süre",
      "AVG_REPLY_TIME": "Bu temsilciye atanan konuşmalarda, müşterilerin mesajı ile temsilcinin yanıtı arasında bekledikleri ortalama süre",
      "ONLINE_TIME": "Seçilen dönemde temsilcinin çevrimiçi veya meşgul olduğu toplam süre",
      "QUEUE_AVAILABLE_TIME": "Seçilen dönemde temsilcinin telefon kuyruklarında müsait olduğu toplam süre"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Telefon Raporları",
    "DESCRIPTION": "Temsilciye veya gelen kutusuna göre gruplandırılmış, gelen ve giden çağrılara dair ayrıntılı bilgilerle telefon görüşmesi metriklerini takip edin.",
    "DOWNLOAD_PHONE_REPORTS": "Telefon Raporlarını İndir",
    "GROUP_BY": {
      "LABEL": "Grupla",
      "AGENT": "Kullanıcı",
      "INBOX": "Gelen Kutusu"
    },
    "TABLE": {
      "TOTAL_CALLS": "Toplam",
      "INBOUND_CALLS": "Gelen",
      "OUTBOUND_CALLS": "Giden",
      "FAILED_OUTBOUND_CALLS": "Başarısız giden",
      "AVG_AGENT_HANDLED_DURATION": "Ort. Süre",
      "TOTAL_AGENT_HANDLED_DURATION": "Toplam Süre",
      "AVG_RINGING_TIME": "Ort. Çalma Süresi",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Başarı %",
      "UNIQUE_CALLERS": "Tekil Arayanlar",
      "UNIQUE_CALLED_CONTACTS": "Tekil Aranan",
      "UNANSWERED_MISSED_CALLS": "Takipsiz Cevapsız",
      "UNANSWERED_MISSED_PERCENTAGE": "Takipsiz Cevapsız %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Takipsiz Cevapsız, Yetersiz Geri Arama",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Takipsiz Cevapsız, Yetersiz Geri Arama %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Tüm çağrıların toplam sayısı (bağlanamayanlar dahil)",
      "INBOUND_CALLS": "Bağlanan çağrı sayısı",
      "OUTBOUND_CALLS": "Tüm giden çağrıların sayısı (bağlanamayanlar dahil)",
      "FAILED_OUTBOUND_CALLS": "Bağlanamayan giden çağrı sayısı",
      "AVG_AGENT_HANDLED_DURATION": "Temsilciler tarafından karşılanan çağrıların ortalama süresi",
      "TOTAL_AGENT_HANDLED_DURATION": "Temsilciler tarafından karşılanan tüm çağrıların toplam süresi",
      "AVG_RINGING_TIME": "Çağrıların yanıtlanmadan önce çalma durumunda geçirdiği ortalama süre",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Başarıyla bağlanan giden çağrıların yüzdesi",
      "UNIQUE_CALLERS": "Gelen çağrı yapan tekil kişi sayısı",
      "UNIQUE_CALLED_CONTACTS": "Giden çağrı ile aranan tekil kişi sayısı",
      "UNANSWERED_MISSED_CALLS": "Başarılı bir geri arama yapılmamış (çağrı bağlanmamış) cevapsız çağrı sayısı. İş günü içinde hâlâ ele alınabilecek çağrıları içerebilir",
      "UNANSWERED_MISSED_PERCENTAGE": "Çağrıları takipsiz cevapsız kalan tekil arayanların yüzdesi (takipsiz cevapsız çağrılar / tekil arayanlar)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "2'den az geri arama denemesi yapılan cevapsız çağrı sayısı. İş günü içinde hâlâ ele alınabilecek çağrıları içerebilir",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "2'den az geri arama denemesi yapılan tekil arayanların yüzdesi ((takipsiz cevapsız - yeterince ele alınan) / tekil arayanlar)"
    }
  }
}
